import React from "react";
import Button from "../form/Button";

const EligibilityPassedContent = ({
  okHandler = () => {},
  applyHandler = () => {},
}) => {
  return (
    <>
      <div className="flex items-center justify-center gap-2 mb-4 mt-5">
        <div className="text-2xl text-green-500">
          <i className="fa-regular fa-fw fa-circle-check"></i>
        </div>
        <div className="text-2xl font-semibold font-CanelaDeck">Passed</div>
      </div>
      <div className="font-Gotham font-medium text-center">
        {/* <p>
          Congratulations! You’re eligible to apply, but this does not guarantee
          a scholarship. This is just the first step in the process.
        </p>
        <p>
          You appear eligible to apply, but the application period is closed.
          Check back at the end of the year when submissions reopen Exit.
        </p> */}
        <p>
          Congratulations! You appear eligible—this is just the first of many
          steps in the process.
        </p>
      </div>
      <div className="flex justify-center gap-4 py-8">
        <Button
          buttonLabel={"Ok"}
          buttonFunction={() => {
            okHandler();
          }}
          buttonClasses="!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-40"
          buttonLabelClasses="!text-base xl:!text-lg"
        />
        <Button
          buttonLabel={"Get Started"}
          buttonFunction={() => {
            applyHandler();
          }}
          buttonClasses="!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-40"
          buttonLabelClasses="!text-base xl:!text-lg"
        />
      </div>
    </>
  );
};

export default EligibilityPassedContent;
